export const MonthlyIncomeFieldData = {
  formControlName: 'monthlyIncome',
  id: 'grit-field-monthly-income',
  type: 'tel',
  prefixIcon: {
    iconName: 'attach_money',
  },
  label: 'Monthly income',
  validationList: [
    {
      errorKey: 'maxAmount',
      args: [99999.99],
      message: "Your monthly income can't be higher than $99,999.99",
    },
    {
      errorKey: 'minAmount',
      args: [1],
      message: 'Your monthly income must be at least $1 to apply for a lease.',
    },
  ],
  requiredMessage:
    'Your monthly income is required to process the application.',
  validCharacters: '0123456789\\.',
};
